export const CLONE_MIN_RECORDING_SECONDS = 10;
export const CLONE_MAX_RECORDING_SECONDS = 20;

const TARGET_SAMPLE_RATE = 16000;

export function combineFloat32Chunks(chunks) {
  const sampleCount = chunks.reduce((count, chunk) => count + chunk.length, 0);
  const combined = new Float32Array(sampleCount);
  let offset = 0;

  chunks.forEach((chunk) => {
    combined.set(chunk, offset);
    offset += chunk.length;
  });

  return combined;
}

function resampleToTargetRate(samples, sourceRate) {
  if (sourceRate === TARGET_SAMPLE_RATE || samples.length === 0) return samples;

  const targetLength = Math.round((samples.length * TARGET_SAMPLE_RATE) / sourceRate);
  if (targetLength <= 1) return samples.slice(0, targetLength);

  const resampled = new Float32Array(targetLength);
  const sourceStep = samples.length <= 1 ? 0 : (samples.length - 1) / (targetLength - 1);

  for (let index = 0; index < targetLength; index += 1) {
    const sourceIndex = index * sourceStep;
    const lowerIndex = Math.min(Math.floor(sourceIndex), samples.length - 1);
    const upperIndex = Math.min(lowerIndex + 1, samples.length - 1);
    const progress = sourceIndex - lowerIndex;
    const lower = samples[Math.min(lowerIndex, samples.length - 1)];
    resampled[index] = lower + (samples[upperIndex] - lower) * progress;
  }

  return resampled;
}

function floatToPCM16(sample) {
  const clamped = Math.max(-1, Math.min(1, sample));
  return clamped < 0 ? clamped * 32768 : clamped * 32767;
}

export function encodeCloneWAV(chunks, sourceRate) {
  const sourceSamples = combineFloat32Chunks(chunks);
  const samples = resampleToTargetRate(sourceSamples, sourceRate);
  const dataLength = samples.length * 2;
  const buffer = new ArrayBuffer(44 + dataLength);
  const view = new DataView(buffer);

  view.setUint32(0, 0x52494646, false);
  view.setUint32(4, 36 + dataLength, true);
  view.setUint32(8, 0x57415645, false);
  view.setUint32(12, 0x666d7420, false);
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, TARGET_SAMPLE_RATE, true);
  view.setUint32(28, TARGET_SAMPLE_RATE * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  view.setUint32(36, 0x64617461, false);
  view.setUint32(40, dataLength, true);

  samples.forEach((sample, index) => view.setInt16(44 + index * 2, floatToPCM16(sample), true));

  return {
    buffer,
    blob: new Blob([buffer], { type: 'audio/wav' }),
    durationSeconds: samples.length / TARGET_SAMPLE_RATE,
    sampleRate: TARGET_SAMPLE_RATE,
  };
}
